class RecommendedProducts {
  constructor() {
    this.listeners();
  }

  listeners() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
  
      observer.unobserve(productRecommendationsSection);
  
      const url = productRecommendationsSection.dataset.url;
  
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          let recommendations;
          const html = document.createElement('div');
          html.innerHTML = text;

          if (productRecommendationsSection.getAttribute('data-metafield-recommendations') === 'true') {
            const recommendationsList = document.querySelector('.js-recommended-products-list');
            recommendations = html.querySelector('.js-recommended-products-items');

            let productForms = recommendations.querySelectorAll('product-form');
            productForms.forEach(form => {
              form.setAttribute('data-update-url', false);
            });

            if (recommendationsList && recommendations && recommendations.innerHTML.trim().length) {
              recommendationsList.innerHTML = recommendations.innerHTML;
            }
          } else {
            recommendations = html.querySelector('.product-recommendations');

            let productForms = recommendations.querySelectorAll('product-form');
            productForms.forEach(form => {
              form.setAttribute('data-update-url', false);
            });

            if (recommendations && recommendations.innerHTML.trim().length) {
              productRecommendationsSection.innerHTML = recommendations.innerHTML;
            }
          }

          if (recommendations && recommendations.innerHTML.trim().length) {
            const productCount = recommendations.querySelectorAll('.product-card').length;
            if (productCount <= 3) {
              productRecommendationsSection.classList.add('product-carousel--centered');
            }
          }


          document.dispatchEvent(new Event('asyncSlider:ready'));
        })
        .catch((error) => {
          console.error(error);
        });
    };
  
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    const productRecommendationsSection = document.querySelector('.product-recommendations');
    
    if (productRecommendationsSection) {
      observer.observe(productRecommendationsSection);
    }
  }
}

window.addEventListener('DOMContentLoaded', function() {
  new RecommendedProducts();
});
